import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { toggleFunnelCalendarView } from 'actions/campaign/addOrEdit'
import { Grid } from '@material-ui/core'
import { CalendarToday, SignalWifi4Bar } from '@material-ui/icons'
import Button from 'components/theme/Button'
import language from 'utils/vast-languagepack'

export default connect(
  state => ({ view: state.campaign.addOrEdit.funnelCalendarView }),
  dispatch => bindActionCreators({ toggleFunnelCalendarView }, dispatch)
)(({ toggleFunnelCalendarView, view }) => (
  <Grid style={{ marginBottom: 5 }} container spacing={24}>
    <Grid item xs={6}>
      <Button
        color='secondary'
        fullWidth
        variant={view === 'calendar' ? 'contained' : 'outlined'}
        onClick={() => toggleFunnelCalendarView('calendar')}
      >
        <CalendarToday style={{ marginRight: 5 }} />
        {language.campaign.add.calendar}
      </Button>
    </Grid>
    <Grid item xs={6}>
      <Button
        color='secondary'
        fullWidth
        variant={view === 'funnel' ? 'contained' : 'outlined'}
        onClick={() => toggleFunnelCalendarView('funnel')}
      >
        <SignalWifi4Bar style={{ marginRight: 5 }} />
        {language.campaign.add.funnel}
      </Button>
    </Grid>
  </Grid>
));
